var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.mobile
    ? _c(
        "footer",
        { staticClass: "page-footer" },
        [
          _c("page-limiter", [
            _c("div", { staticClass: "page-footer__row page-footer__body" }, [
              _vm.nav && _vm.nav.length
                ? _c(
                    "ul",
                    { staticClass: "footer-nav" },
                    [
                      _vm._l(_vm.nav, function(item) {
                        return _c(
                          "li",
                          [
                            _c(
                              "nuxt-link",
                              { attrs: { to: "/" + item.route } },
                              [_vm._v(_vm._s(item.title))]
                            )
                          ],
                          1
                        )
                      }),
                      _c("li", [
                        _c(
                          "a",
                          { attrs: { href: "tel:" + _vm.settings.phoneLink } },
                          [_vm._v(_vm._s(_vm.settings.phone))]
                        )
                      ]),
                      _c("li", [
                        _c(
                          "a",
                          { attrs: { href: "mailto:" + _vm.settings.email } },
                          [_vm._v(_vm._s(_vm.settings.email))]
                        )
                      ])
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "footer-contacts" },
                [
                  _vm.settings.hasSubscribe ? _c("footer-subscribe") : _vm._e(),
                  _c("footer-social", {
                    attrs: { content: _vm.settings.social }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "page-footer__row page-footer__copy" }, [
              _c("small", {
                staticClass: "footer-copy-note",
                domProps: { innerHTML: _vm._s(_vm.copy) }
              }),
              _c(
                "a",
                {
                  staticClass: "footer-dev-mark",
                  attrs: { href: "https://os-design.ru/", target: "_blank" }
                },
                [
                  _c("img", {
                    attrs: {
                      width: "98",
                      height: "13",
                      src: require("static/images/dev-mark.svg"),
                      alt: ""
                    }
                  })
                ]
              )
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90a428b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90a428b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PageFooter.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-90a428b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PageFooter.vue
// module chunks = 5